import axiosInstance from "./http/axios_instance"
const http = axiosInstance("/protected", null )

const getRecentSalesAvg = (postcode, summary_id, bedrooms, rerun) => http.get("/property_recent_sales/" + postcode + "/" +
    summary_id +"/" + bedrooms + "/" + rerun);
const getRecentSales = (postcode, summary_id) => http.get("/property_recent_sales/" + postcode + "/" + summary_id)
export default {
    getRecentSalesAvg,
    getRecentSales
}